module.exports = __webpack_public_path__ + "img/link.ba6400c4.svg";